import React, { useEffect, useState } from 'react';
import Toolbar from '../../organisms/toolbar/Toolbar';
import StepSidebar from '../../organisms/step-sidebar/StepSidebar';
import DesignCanvas from '../../organisms/design-canvas/DesignCanvas';
import EditorOptions from '../../organisms/editor-options/EditorOptions';
import { useDispatch, useSelector } from 'react-redux';
import { loadSteps } from '../../../redux/stepsSlice';
import Loader from '../../organisms/loader/Loader';
import { setMaterial, getMaterial } from '../../../redux/materialSlice';
import { setMainConfig } from '../../../redux/stepsSlice';
import { setLearningMaterialId } from '../../../redux/toolsSlice';
import { http_get } from '../utils/api_client';
import { API_ENDPOINTS } from '../utils/endpoints';
import { fetchCompanyDetails, getCompany } from '../../../redux/companySlice';
import WalkthroughEditorShell from './v2/WalkthroughEditorShell';

// Walkthrough Editor v2 (Phase 0 authoring redesign). Mirrors the Path Editor
// v2 pattern: flip to false to instantly revert to the legacy editor kept
// intact below. Reaches production only when this branch is merged at BL-146.
const USE_V2 = true;

const Editor = ({ id, preview }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setLearningMaterialId(id));
  }, [id]);

  const [isLoading, setIsLoading] = useState(true);
  const material = useSelector((state) => getMaterial(state));
  const companyName = material.company_name;
  const materialName = material.name;

  const loadMaterial = () => {
    setIsLoading(true);
    http_get(API_ENDPOINTS.GET_WALKTHROUGH(id))
      .then((res) => {
        const steps = res.data.data;
        dispatch(setMaterial(res.data));
        dispatch(setMainConfig({config: res.data.config, type: 'walkthrough'}));
        dispatch(loadSteps(steps));
      })
      .catch((err) => { })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadMaterial();
    dispatch(fetchCompanyDetails());
  }, []);

  // Content-aware browser tab: show the walkthrough's name once it loads
  // (falls back to the server-rendered section title until then).
  useEffect(() => {
    if (materialName) document.title = `${materialName} · UserNurture`;
  }, [materialName]);

  return (
    <>
      {isLoading && <Loader />}
      {!isLoading && (
        USE_V2 ? (
          <WalkthroughEditorShell
            id={id}
            companyName={companyName}
            materialName={materialName}
            initialPreview={preview}
          />
        ) : (
          <>
            <Toolbar
              id={id}
              companyName={companyName}
              materialName={materialName}
            />
            <div className="editor-body">
              <StepSidebar />
              <DesignCanvas />
              <EditorOptions />
            </div>
          </>
        )
      )}
    </>
  );
};

export default Editor;
